export default __webpack_public_path__ + "static/media/street.006cd1b5.jpg";